/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import MediaMenuItem from '../MediaMenu/MediaMenuItem'
import { IconType } from '@bt-react/components/Icon'
import { ScreenShareButtonProps } from './types'

const ScreenShareButton: React.FC<ScreenShareButtonProps> = ({
  selected = false, disabled = false,
  currentMediaType, publishScreen, presenterLayoutsActive
}) =>

  <MediaMenuItem
    onClick={!selected ? () => publishScreen(presenterLayoutsActive, currentMediaType) : () => {}}
    dataBdd={'talks-share-screen-button'}
    active={selected}
    disabled={disabled}
    icon={IconType.iconName.screen}
    text={`Share screen`}
    mediaType='SCREENSHARE'
  />

export default ScreenShareButton
